export default __webpack_public_path__ + "static/media/transaction-arrows.dba5833b.svg";